import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Component, OnDestroy, OnInit, viewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { finalize, takeUntil, tap } from 'rxjs/operators';

import {
  CreateP2PSmartSmsRecipientsCommand,
  CreateP2PSmartSmsRecipientsDetail,
  GetSmartSmsRequestByIdDto,
  GetSmartSmsRequestRecipientDto,
  SendTypes,
  SmartRequestTypes,
  SmartSmsRequestStatus,
  SmartSmsStatus,
  SmsAggregator,
  SmsCp,
} from 'src/app/core/api/models';
import {
  SmartSmsRecipientsService,
  SmartSmsRequestsService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AuthTokenService } from 'src/app/core/services/authentication/auth-token.service';
import { ConsoleService } from 'src/app/core/services/console.service';
import { FileService } from 'src/app/core/services/file.service';
import { SmartSmsShareMemoryService } from 'src/app/core/services/smart-sms-shareMemory.service';
import { AppSelectedAggregator } from 'src/app/core/types/app-selected-aggregator.type';
import { SmartSendConfirmationMapComponent } from 'src/app/shared/components/smart-send-confirmation-map/smart-send-confirmation-map.component';
import { PrivateNumbersService } from '../../../core/api/services/private-numbers.service';
import { ScheduledMessagesService } from '../../../core/api/services/scheduled-messages.service';
import {
  DialogService,
  DialogStatus,
} from '../../../core/services/dialog.service';
import { DynamicTabService } from '../../../core/services/dynamic-tab.service';
import { UtilityService } from '../../../core/services/utility.service';
import { SendP2pSmsComponent } from '../../sending-system/send-p2p-sms/send-p2p-sms.component';
import { TabsDynamicComponent } from './../../../layout/components/tabs-dynamic/tabs-dynamic.component';

@Component({
    selector: 'app-p2p-smart-sms',
    templateUrl: './p2p-smart-sms.component.html',
    styleUrls: [
        './p2p-smart-sms.component.scss',
        '../../sending-system/base/base-sending-system.component.scss',
    ],
    standalone: false
})
export class SendP2pSmartSmsComponent
  extends SendP2pSmsComponent
  implements OnInit, OnDestroy
{
  //#region properties
  tabName: string = 'sendP2pSmartSms';
  model: CreateP2PSmartSmsRecipientsCommand = {};
  readonly Map = viewChild<SmartSendConfirmationMapComponent>('Map');

  data: GetSmartSmsRequestByIdDto;
  dataLoaded: boolean = false;
  isPeriodicRequest: boolean = false;
  lastSubmittedRec: GetSmartSmsRequestRecipientDto[] = [];
  selectedMode: AppSelectedAggregator = 'hamrahAval';
  isExistsMCI: boolean = false;
  isExistsIrancell: boolean = false;
  isExistsRightel: boolean = false;
  isShowMap: boolean = true;

  get SmsCp() {
    return SmsCp;
  }
  get SmsAggregator() {
    return SmsAggregator;
  }
  operators: Array<SmsAggregator> = [];
  selectedOperator: SmsAggregator;

  pattern;
  sendDateTime;
  privateNumber;

  filePath: string = '';

  Model = [];

  importedColList: string[] = [];
  previewModel: any[] = [];
  //#endregion

  constructor(
    private scheduleMessageService: SmartSmsRecipientsService,
    private smartRequestService: SmartSmsRequestsService,
    private smartSmsRecipientsService: SmartSmsRecipientsService,

    protected currentService: ScheduledMessagesService,
    protected dialogService: DialogService,
    protected utilityService: UtilityService,
    protected translate: TranslateService,
    protected dynamicTabService: DynamicTabService,
    protected privateNumberService: PrivateNumbersService,
    protected smartSmsShareMem: SmartSmsShareMemoryService,
    protected fileService: FileService,
    protected http: HttpClient,
    protected tabsDynamicComponent: TabsDynamicComponent
  ) {
    super(
      currentService,
      dialogService,
      utilityService,
      translate,
      dynamicTabService,
      privateNumberService,
      fileService,
      http,
      tabsDynamicComponent
    );
    this.baseCreateGetApiForSend(
      this.smartSmsRecipientsService,
      'smartSmsRecipientsCreateP2PSmartSmsRecipientsGet'
    );
  }

  ngOnInit() {
    try {
      window.scroll(0, 0);
      this.getUserState();
      this.getVocabs();
      this.initForm();
      this.initModel();
      this.pageVocabs = 'pages.sendP2pSmartSms.';
      this.configDirectDateTimeComponent();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  initForm() {
    this.form = new FormGroup({
      senderNumberId: new FormControl('', Validators.required),
      inputFile: new FormControl('', Validators.required),
      sendDate: new FormControl('', Validators.required),
      sendTime: new FormControl('', Validators.required),
      description: new FormControl(''),
    });
  }

  //#region Api

  //create
  baseCreateApi(model: CreateP2PSmartSmsRecipientsCommand) {
    this.unSubs();
    this.sendLoading = true;
    this.loading = true;
    let recipients: Array<CreateP2PSmartSmsRecipientsDetail> = [];
    this.operators.forEach((item) => {
      let recipient: CreateP2PSmartSmsRecipientsDetail = {};
      let smartRecipients = this.lastSubmittedRec.filter(
        (rec) => rec.operator == item
      );

      recipient.smartSmsRecipients = smartRecipients;
      recipient.operator = item;
      recipients.push(recipient);
    });

    model.recipients = recipients;
    model.privateNumberNumber = this.privateNumber;
    model.sendDateTime = this.sendDateTime;
    //  model.pattern = this.pattern.toUpperCase();
    model.pattern = this.pattern?.replace(/\[(.*?)\]/g, (item) =>
      item.toUpperCase()
    );

    model.path = this.apiUrl + '/' + this.filePath;

    this.scheduleMessageService
      .smartSmsRecipientsCreateP2PSmartSmsRecipientsPost({ body: model })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.sendLoading = false))
      )
      .subscribe((result) => {
        try {
          this.apiNotificationService.notifyMessage({
            result,
            mode: 'matDialog',
          });
          if (result.isSucceed) {
            this.onSuccess();
            this.refreshPage();
          }
        } catch (error) {
          this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
        }
      });
  }

  loadWithRequestId(id: number) {
    this.loading = true;
    this.smartRequestService
      .smartSmsRequestsGetSmartSmsRequestById({
        SmartSmsRequestId: id,
      })
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => (this.loading = false))
      )
      .subscribe((res) => {
        try {
          if (
            res?.data?.status == SmartSmsRequestStatus.Done ||
            res?.data?.status == SmartSmsRequestStatus.PartOfRequestIsCompleted
          ) {
            if (
              res?.data?.smartRequestType ==
                SmartRequestTypes.WelcomeForAirports ||
              res?.data?.smartRequestType == SmartRequestTypes.WelcomeForCity ||
              res?.data?.smartRequestType ==
                SmartRequestTypes.WelcomeForProvince
            )
              this.isShowMap = false;

            this.dataLoaded = true;
            this.data = res?.data;
            let obj = JSON.parse(res?.data.responseData);
            (Object.keys(obj) as (keyof typeof obj)[]).forEach((key, index) => {
              obj[key] = JSON.parse(obj[key]);
            });
            this.Model = [];

            this.data.recipients.forEach((element) => {
              if (element.operator == SmsAggregator.MCI)
                this.isExistsMCI = true;
              if (element.operator == SmsAggregator.Irancell)
                this.isExistsIrancell = true;
              if (element.operator == SmsAggregator.Rightel)
                this.isExistsRightel = true;

              var item = {
                id: element.id,
                total: element.count,
                sendCount: element.count,
                persianPrice: element.persianPrice,
                englishPrice: element.englishPrice,
                startFrom: 1,
                polygon: [element.coordinates],
                operator: element.operator,
              };
              this.Model.push(item);
            });
            if (this.Model.length > 0) this.Map().setModel(this.Model);
          } else {
            this.dataLoaded = false;
          }
          if (!this.dataLoaded) {
            try {
              this.dialogService.openDialog({
                message:
                  this.translate.instant(
                    this.pageVocabs + 'errors.couldNotEditRequest'
                  ) +
                  '<br>' +
                  this.translate.instant(
                    this.pageVocabs +
                      'errors.pleaseWaitUntilTheRequestStateChanged'
                  ),
                status: DialogStatus.error,
              });
            } catch (error) {
              this.loggerService.logError(
                this.tagName,
                error,
                EventTypes.smartSms
              );
            }
          }
        } catch (error) {
          this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
        }
      });
  }

  //#endregion

  onMapLoad() {
    let id = this.smartSmsShareMem.getScheduledMessageId();
    if (this.smartSmsShareMem.getScheduledMessageId() > 0) {
      this.model.smartSmsRequestId = id;
      this.loadWithRequestId(id);
    }
  }

  readFileSmartP2P(file: File) {
    try {
      this.previewModel = null;
      this.importedColList = [];

      this.loading = true;

      if (file == null || file == undefined) {
        this.jsonData = null;
        this.loading = false;
        this.totalEntry = 0;
        this.importedColList = [];
        return;
      }

      this.progress = 1;
      let formData: any = new FormData();
      let fileToUpload = <File>file;

      formData.append(
        'file',
        fileToUpload,
        fileToUpload.name.replace(/\s/g, '')
      );
      formData.append('sendTypes', SendTypes.SmartP2P);

      const headers = new HttpHeaders()
        .set('Accept', 'application/json')
        .set('enctype', 'multipart/form-data')
        .set('ngsw-bypass', 'true')
        .set('Authorization', 'Bearer ' + AuthTokenService.getAccessToken());
      this.http
        .post(this.action, formData, {
          headers: headers,
          reportProgress: true,
          observe: 'events',
        })
        .pipe(
          this.basePipeOperators(),
          tap((event: any) => {
            if (event.type == HttpEventType.UploadProgress) {
              ConsoleService.info('loaded', event.loaded);
              ConsoleService.info('loaded', event.total);

              this.progress = Math.round((100 / event.total) * event.loaded);
            } else if (event.type == HttpEventType.Response) {
              this.progress = null;
            }
          })
        )
        .subscribe((result) => {
          if (result.body) {
            result = result.body;
            this.apiNotificationService.notifyMessage({ result });
            if (result.isSucceed) {
              let data = JSON.parse(result?.data);
              this.filePath = data.path;
              this.importedColList = [];

              this.jsonData = null;
              this.totalEntry = 0;
              this.loading = false;

              if (this.fileService.isValidColumnNames(data.data[0])) {
                this.importedColList = data.data[0];
                this.finalImportedColList = this.importedColList?.map(
                  (str) => ({
                    value: str,
                  })
                );
                this.jsonData = data.data;
                this.totalEntry = this.jsonData.length;
                this.getPreviewModelSmartP2P();
              }
            }
          }
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  getPreviewModelSmartP2P() {
    try {
      this.previewModel = [];
      for (let index = 1; index < this.jsonData.length; index++) {
        this.previewModel.push(Object.values(this.jsonData[index]));
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (!this.isValidForm(this.smsBodyGenerator, 'P2pSmsBodyGeneratorForm'))
        return;
      if (this.importedColList.length === 0 && !this.pattern) {
        return;
      }
      if (!this.form.valid || this.loading || this.jsonData == null) return;

      if (this.operators.length <= 0) {
        this.dialogService.openDialog({
          title: this.translate.instant('common.error'),
          message: this.translate.instant(
            this.pageVocabs + 'errors.mustSelectOperator'
          ),
          status: DialogStatus.error,
        });
        return;
      }

      //call api method
      this.lastSubmittedRec = [];
      this.Map().getModel()?.forEach((item) => {
        if (this.operators.includes(item.operator)) {
          var nIt: GetSmartSmsRequestRecipientDto = {
            coordinates: item.polygon[0],
            count: item.sendCount,
            englishPrice: item.englishPrice,
            fromIndex: item.startFrom,
            id: item.id,
            persianPrice: item.persianPrice,
            status: SmartSmsStatus.Done,
            operator: item.operator,
          };
          this.lastSubmittedRec.push(nIt);
        }
      });

      this.baseCreateApi(this.model);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  setPrivateNumber(privateNumber) {
    this.privateNumber = privateNumber.number;
  }
}
